/**
 * Adjust the height of a textarea element
 * @param element The textarea element to adjust
 */
export const adjustTextareaHeight = (element: HTMLTextAreaElement) => {
  element.style.height = 'auto';
  const maxHeight = 250; // approximately 10 lines
  if (element.scrollHeight <= maxHeight) {
    element.style.height = `${element.scrollHeight}px`;
    element.style.overflowY = 'hidden';
  } else {
    element.style.height = `${maxHeight}px`;
    element.style.overflowY = 'auto';
  }
};

/**
 * Scroll an element into view at the bottom of its container
 * @param container The element to scroll into view
 */
export const scrollToBottom = (container: HTMLElement | null) => {
  if (!container) return;
  requestAnimationFrame(() => {
    container.scrollTo({
      top: container.scrollHeight,
      behavior: 'smooth',
    });
  });
};
